/**
 * Flickr Photosets
 *
 * @author      Mickael BLATIERE
 * @license     http://www.opensource.org/licenses/mit-license.php - Licensed under The MIT License
 * @link        http://github.com/blat/jquery-flickr-plugin
 * Forked by    Rudy Affandi
 * Changes      - Added support for Fancybox2
 *              - added more image sizes
 *              - edited to fit to Adnet template
 */

(function($) {

    var api_url = 'https://api.flickr.com/services/rest/';

    var options = {};
    var default_options = {
        user_id: null,
        api_key: null,
        size: 'normal',
        speed: 100,
        count: false
    };

    var root;
    var photos = [];

    $.fn.flickr = function(user_options) {
        root = $(this);
        if (!user_options) user_options = {};
        $.each(default_options, function(key, default_value) {
            options[key] = user_options[key] || default_value;
        });
        flickr_init();
    }

    flickr_init = function() {
        flickr_request('flickr.photosets.getList', {user_id: options.user_id});
    }

    flickr_photosets = function(photosets) {
        var element = $('<ul></ul>', {id: 'flickr'});
        root.append(element);

        var size = '_m';
        switch (options.size) {
            case 'small-square': // small square 75x75
                size = '_s';
                break;
            case 'large-square': // large square 150x150
                size = '_q';
                break;
            case 'thumbnail': // thumbnail, 100 on longest side
                size = '_t';
                break;
            case 'small-240': // small, 240 on longest side
                size = '_m';
                break;
            case 'small-320': // small, 320 on longest side
                size = '_n';
                break;
            case 'medium': // medium, 500 on longest side
                size = '';
                break;
            case 'medium-640': // medium 640, 640 on longest side
                size = '_z';
                break;
            case 'medium-800': // medium 800, 800 on longest side
                size = '_c';
                break;
            case 'large': // large, 1024 on longest side
                size = '_b';
                break;
            case 'original': // original image, either a jpg, gif or png, depending on source format
                size = '_o';
                break;
        }

        $.each(photosets.photoset, function(key, photoset) {
            if (!options.count || key < options.count) {
                var thumbnail = 'https://farm' + photoset.farm + '.static.flickr.com/' + photoset.server + '/' + photoset.primary + '_' + photoset.secret + size + '.jpg';
                var title = photoset.title._content;
                var description = photoset.description._content;
                element.append($('<li></li>')
                    .append($('<a></a>', {id: photoset.id, title: title})
                        //.css({'background': 'url(' + thumbnail + ') no-repeat 0 0', 'background-size': 'contain'})
                        .addClass(options.size)
                        .append($('<img></img>', {src: thumbnail}))
                        .append($('<div class="title"></div>').text(title))
                        .append($('<div class="desc"></div>').text(description))
                        .click(function() { flickr_lightbox($(this).attr('id')); return false; })
                    ).hide()
                    .append($('<img></img>', {src: thumbnail}).hide())
                );
                $('ul#flickr li').filter(':odd').addClass('odd');
                $('ul#flickr li').filter(':even').addClass('even');
            }
        });
        flickr_preload();
    }

    flickr_lightbox = function(id) {
        var fbRegular = {openEffect: 'fade', closeEffect: 'fade', prevEffect: 'fade', nextEffect: 'fade', prevSpeed: 'slow', nextSpeed: 'slow', helpers: {title : {type : 'inside'}}};
        var fbGallery = {openEffect: 'fade', closeEffect: 'fade', prevEffect: 'fade', nextEffect: 'fade', prevSpeed: 'slow', nextSpeed: 'slow', mouseWheel: true, helpers: {buttons : {}, title : {type : 'inside'}, thumbs: {width: 100, height: 75}}};

        if (photos[id]) {
            //$.fancybox(photos[id], {type: 'image'}); // Using older fancybox API
            $.fancybox(photos[id], fbGallery); // Using new Fancybox 2 API
        } else {
            flickr_request('flickr.photosets.getPhotos', {photoset_id: id});
        }
    }

    flickr_animate = function() {
        $('#flickr li:hidden:first').fadeIn(options.speed, flickr_animate);
    }

    flickr_preload = function() {
        var images = $('#flickr li img');
        var count = images.length;
        images.one('load', function() {
            count--;
            if (count == 0) {
                flickr_animate();
            }
        }).each(function(){
            if (this.complete)  $(this).trigger("load");
        });
    }

    flickr_photoset = function(photoset) {
        photos[photoset.id] = [];
        $.each(photoset.photo, function(key, photo) {
            photos[photoset.id][key] = {
                href: 'https://farm' + photo.farm + '.static.flickr.com/' + photo.server + '/' + photo.id + '_' + photo.secret + '_b.jpg',
                title: photo.title
                //title: $('#' + photoset.id).attr('title')
            };
        });
        flickr_lightbox(photoset.id);
    }

    flickr_request = function(method, data) {
        var url = api_url + "?format=json&method=" + method + "&api_key=" + options.api_key;
        $.each(data, function(key, value) {
            url += "&" + key + "=" + value;
        });
        $.getScript(url);
    }

})(jQuery);

function jsonFlickrApi(rsp){
    if (rsp.stat != "ok") {
        return;
    }

    if (rsp.photosets) flickr_photosets(rsp.photosets);
    else if (rsp.photoset) flickr_photoset(rsp.photoset);
}

